import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../../../../store/actions';
import classnames from 'classnames';
import { withStyles, Typography, List, ListItem } from '@material-ui/core';
import { SearchInput } from '../../../../components';
import logo from '../../../../assets/Images/edit.png';
import menuimg from '../../../../assets/Images/menuimg.png';

// Component styles
import styles from './styles';
import UserPopover from './components/UserPopover/UserPopover';

class Navbar extends Component {
  state = { showMenu: false, scrollPos: window.pageYOffset };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    this.setState({
      scrollPos: window.pageYOffset
    });
  };

  render() {
    const { showMenu, scrollPos } = this.state;
    const { classes, isAuth, user, logout, search, onChangeSearch } =
      this.props;

    return (
      <Fragment>
        {/* <div className={ classes.pad}/> */}
        <nav
          className={classnames({
            [classes.navbar]: true,
            [classes.navbarColor]: scrollPos > 30
          })}>
          <Link className={classes.logoLink} to="/">
            <Typography className={classes.logo} variant="h2">
              <img src={logo} className={classes.logo} />
            </Typography>
          </Link>
          <div className={classes.navLinks}>
            <Link className={classes.navLink} to="/">
              Home
            </Link>
            <Link className={classes.navLink} to="/movie/category/nowShowing">
              Now Showing
            </Link>
            <Link className={classes.navLink} to="/movie/category/comingSoon">
              Coming Soon
            </Link>
            <Link className={classes.navLink} to="/events">
              Events
            </Link>
            {/* <Link className={classes.navLink} to="/cinemas">
              Cinemas
            </Link> */}
            <Link className={classes.navLink} to="/ContactUs">
              Contact Us
            </Link>
            <SearchInput
              className={classes.searchInput}
              placeholder="Search Movie"
              value={search}
              onChange={onChangeSearch}
            />
          </div>

          <div className={classes.navAccount}>
            <UserPopover logout={logout}>
              <List component="nav">
                {user && user.permissions && user.permissions.some(permission => permission !== 'confirm_arrived') ? (
                  <ListItem>
                    <Link
                      className={classes.navLink}
                      to={
                        user.role !== 'guest'
                          ? '/admin/dashboard'
                          : '/mydashboard'
                      }>
                      Dashboard
                    </Link>
                  </ListItem>
                ) : null}


                {isAuth ? (
                  <ListItem>
                    <Link className={classes.navLink} onClick={logout} to="/">
                      Logout
                    </Link>
                  </ListItem>
                ) : (
                  <ListItem>
                    <Link className={classes.navLink} to="/login">
                      Login
                    </Link>
                  </ListItem>
                )}
              </List>
            </UserPopover>
          </div>

          <div className={classes.navMobile}>
            <div
              className={classes.navIcon}
              onClick={() => this.setState({ showMenu: !this.state.showMenu })}>
              <div
                className={classnames(
                  classes.navIconLine,
                  classes.navIconLine__left
                )}
              />
              <div className={classes.navIconLine} />
              <div
                className={classnames(
                  classes.navIconLine,
                  classes.navIconLine__right
                )}
              />
            </div>
          </div>
        </nav>
        <div
          className={classnames({
            [classes.navActive]: showMenu,
            [classes.nav]: true
          })}>
          <div className={classes.navContent}>
            {/* <img
              src={menuimg}
              style={{
                position: 'fixed',
                bottom: 0,
                animation: 'fadeIn 0.5s ease-in-out 5s forwards' // Animation with 5s delay
              }}
            /> */}

            <div className={classes.currentPageShadow}>Movies</div>
            <ul
              className={classes.innerNav}
              onClick={() => this.setState({ showMenu: !this.state.showMenu })}>
              <li className={classes.innerNavListItem}>
                <Link className={classes.innerNavLink} to="/">
                  Home
                </Link>
              </li>
              <li className={classes.innerNavListItem}>
                <Link
                  className={classes.innerNavLink}
                  to="/movie/category/nowShowing">
                  Now Showing
                </Link>
              </li>
              <li className={classes.innerNavListItem}>
                <Link
                  className={classes.innerNavLink}
                  to="/movie/category/comingSoon">
                  Coming Soon
                </Link>
              </li>
              <li className={classes.innerNavListItem}>
                <Link
                  className={classes.innerNavLink}
                  to="/events">
                  Events
                </Link>
              </li>
              {/* <li className={classes.innerNavListItem}>
                <Link className={classes.innerNavLink} to="/cinemas">
                  Cinemas
                </Link>
              </li> */}
              <li className={classes.innerNavListItem}>
                <Link className={classes.innerNavLink} to="/ContactUs">
                  Contact uS
                </Link>
              </li>
              <li>{/* <div className={classes.row}> */}</li>
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.authState.isAuthenticated,
  user: state.authState.user
});

const mapDispatchToProps = {
  logout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Navbar));
